var SimpleMap = new Class({
	Extends: DisplayObject,
	Implements: [Options, Events],
	options: {
		cls: 'w_googlemaps',
		zoom: 12, //0 is the smallest zoom (means, that you can see the whole world)
		max_zoom: 22,
		min_zoom: 1,
		lat: 40.773522,
		lng: -73.944862,
		type: 'roadmap', //roadmap, satellite or hybrid
		pan_control: false,
		zoom_control: true,
		zoom_control_style: 'normal', //can be small or normal
		zoom_control_position: null,
		type_control: false,
		scale_control: false,
		overview_control: false,
		street_view_control: false,
		scrollwheel: true,
		disableDoubleClickZoom: false,
		fullscreenControl: false,
		draggable: true,
		styled: true,
		add_lazy_load : true,
		transit_layer: false,
		map_styles: [
			{
				"featureType": "transit.station.bus",
				"stylers": [
					{ "visibility": "off" }
				]
			},{
				"featureType": "poi.park"
			},{
				"featureType": "poi",
				"elementType": "labels",
				"stylers": [
					{ "visibility": "off" }
				]
			},
		]
	},
    // setOptions: function(){
    //     var options = this.options = Object.merge.apply(null, [{}, this.options].append(arguments));
    //     if (this.addEvent) for (var option in options){
    //         if (typeOf(options[option]) != 'function' || !(/^on[A-Z]/).test(option)) continue;
    //         if (option !== 'onBoundsChanged') {
    //             this.addEvent(option, options[option]);
    //             delete options[option];
    //         }
    //     }
    //     return this;
    // },
	initialize: function(element, options){
		var self = this;
		if(typeOf(element) == 'string'){
			this._element = document.getElement(element);
		}else{
			this._element = element;
		}
		var loaded = false;

		if (this._element) {
			this.setOptions(options);
			this.parent();
		}
	},

	build: function(){
		this.parent();

		this.markers = [];
		this.map_is_ready = false;

		var loaded = false;
		var lazyloadOffset = 500;

		if (!this.options.add_lazy_load || !loaded && this._element.getPosition().y !== 0 && this._element.getPosition().y < window.getScroll().y + window.innerHeight + lazyloadOffset) {
			Core.load_google_api(this.defer_build.bind(this));
			loaded = true;
		}

		window.addEvent('scroll', function(){
			if (!loaded && this.options.add_lazy_load && this._element.getPosition().y !== 0 && this._element.getPosition().y < window.getScroll().y + window.innerHeight + lazyloadOffset) {
				Core.load_google_api(this.defer_build.bind(this));
				loaded = true;
			}
		}.bind(this));
	},

	defer_build: function(){
		var self = this;

		if(!google.maps.MapTypeId){
			(function(){
				this.defer_build();
			}.bind(this)).delay(50);

			return;
		}

		var opts = this.options;
		var map_type = google.maps.MapTypeId.ROADMAP;

		if(opts.type == 'satellite'){
			map_type = google.maps.MapTypeId.SATELLITE;
		}else if(opts.type == 'hybrid'){
			map_type = google.maps.MapTypeId.HYBRID;
		}

		this.map = new google.maps.Map(this._element, {
			zoom: opts.zoom,
			maxZoom: opts.max_zoom,
			minZoom: opts.min_zoom,
			center: new google.maps.LatLng(opts.lat, opts.lng),
			mapTypeId: map_type,
			disableDoubleClickZoom: opts.disableDoubleClickZoom,
			scrollwheel: opts.scrollwheel,
			streetViewControl: opts.street_view_control,
			panControl: opts.pan_control,
			zoomControl: opts.zoom_control,
			clickableIcons: false,
			draggable: opts.draggable,
			zoomControlOptions: {
				style: (opts.zoom_control_style == 'small' ? google.maps.ZoomControlStyle.SMALL : null),
				position: (opts.zoom_control_position == 'right' ? google.maps.ControlPosition.TOP_RIGHT 
					: (opts.zoom_control_position == 'bottomRight' ? google.maps.ControlPosition.RIGHT_BOTTOM 
					: (opts.zoom_control_position == 'rightTop' ? google.maps.ControlPosition.RIGHT_TOP
					: null)))
			},
			mapTypeControl: opts.type_control,
			scaleControl: opts.scale_control,
			overviewMapControl: opts.overview_control,
			fullscreenControl: opts.fullscreenControl,
			bubble_options: {
				visible: true
			},
			styles: opts.map_styles || {}
		});

		this.map.addListener('tilesloaded', function() {
			self.fireEvent('tilesLoaded');
		});

		this.map.addListener('idle', function() {
			self.fireEvent('idle');
		});
	
		this.map.addListener('bounds_changed', (function () {
			var bounds = this.map.getBounds();
			var ne = bounds.getNorthEast();
			var sw = bounds.getSouthWest();
			var boundsInfo = {
				topLeft: { lat: ne.lat(), lng: sw.lng() },
				bottomRight: { lat: sw.lat(), lng: ne.lng() }
			};
			// Call the callback function with the bounds info
			self.fireEvent('boundsChanged', boundsInfo);
		}).bind(this));

		this.map_is_ready = true;
		this.fireEvent('mapReady', [this]);

		if (this.options.transit_layer) {
			this.transitLayer = new google.maps.TransitLayer();
			this.transitLayer.setMap(this.map);
		}
	},

	add_marker: function(opts){
		if(this.map_is_ready){
			var sm_marker = new SimpleMap.Marker(this.map, opts);
			this.markers.push(sm_marker.marker);
			return sm_marker;
		}

		this.addEvent('mapReady', this.add_marker.bind(this, opts));

		return null;
	},

	add_circle: function(opts){
		if(this.map_is_ready){
			var center = new google.maps.LatLng(opts.lat, opts.lng);

			var sm_circle = new google.maps.Circle({
				center: center,
				radius: opts.size || 0,

				strokeColor: opts.color || "#c03e62",
				strokeOpacity: 1,
				strokeWeight: opts.weight || 2,
				fillColor: opts.color || "#c03e62",
				fillOpacity: 0
			});

			sm_circle.setMap(this.map);

			return sm_circle;
		}

		this.addEvent('mapReady', function(){
			this.add_circle(opts);
		}.bind(this));

		return null;
	},

	animate_circle: function(circle){
		if(!circle || !circle.active || circle.is_animating) return;

		var opacity = 12;
		var radius = 0;

		circle.setOptions({
			radius: radius
		});

		circle.setVisible(true);

		var period;

		var increments = [
			150000,
			100000,
			60000,
			32000,
			20000,
			11000,
			6000,
			3000,
			1500,
			750,
			380,
			200,
			100,
			60,
			30,
			15,
			8,
			5,
			2,
			1
		];

		var increment = increments[this.map.zoom] || 1;

		var __animate = function(){
			if(opacity == 0){
				clearInterval(period);
				circle.setVisible(false);
				circle.is_animating = false;
				this.animate_circle(circle);

				return;
			}

			radius = radius + increment;

			circle.setOptions({
				radius: radius,
				strokeOpacity: opacity / 24
			});

			opacity--;
		}.bind(this);

		circle.is_animating = true;

		period = __animate.periodical(100);
	},

	clear_markers: function(){
		this.markers.each(function(el){
			el.setMap(null);

			if(el.label){
				el.label.close();
			}
		});

		this.markers = [];
	},

	fit_markers: function(){
		if(this.map_is_ready){
			var bounds = new google.maps.LatLngBounds();

			this.markers.each(function(el){
				bounds.extend(el.getPosition());
			});

			this.map.fitBounds(bounds);
			this.map.setCenter(bounds.getCenter());

			return;
		}

		this.addEvent('mapReady', function(){
			this.fit_markers();
		}.bind(this));
	},

	set_center: function(lat, lng){
		this.map.panTo(new google.maps.LatLng(lat, lng));
	},

	get_zoom: function(){
		return this.map.getZoom();
	},

	set_zoom: function(zoomLevel){
		return this.map.setZoom(zoomLevel);
	},

	in_new_york: function(lat, lng){ //some properties have wrong coordinates, that's why it's needed to be verified
		// return true;
		if(!lat || !lng) return false;

		return (lat < 41.2 && lat > 40.4 && lng < -73.1 && lng > -74.4);
	}

});

SimpleMap.Marker = new Class({
	Implements: [Events, Options],

	options: {
		id: null,
		lat: 40.773522,
		lng: -73.944862,
		icon: null,
		hover_icon: null,
		bubble:{
			content: null,
			z_index: null,
			add_class: '',
			offset: {x: 0, y: 0},
			side: 'top'
		},
		init_open: false, // true : open the tooltip (could be true only for one marker of the map)
		label: {
			content: null,
			add_class: ''
		},
		base_point: 'bottom', //by default base point of the marker is set to bottom-center (use 'center' to set it to center)
		scalable: false,
		center_on_click: true,
		panby_onclick: {
			x: 0,
			y: 0
		}, // on marker click the map centers on marker. this option allows to pan center of the map in pixels (i.e. x: 100 moves center of the map 100px left, y: 100 moves center of the map 100px up)
		callbacks: {},
		size: 1, //1 == 100%,
		current_bubble_open_on_mouseover : false
	},

	initialize: function(map, options){
		if(!options) return;

		this.setOptions(options);

		var opts = this.options;

		if(!map || !opts.lat || !opts.lng) return;

		this.map = map;
		this.latlng = new google.maps.LatLng(opts.lat, opts.lng);

		this.build();
	},

	build: function() {
		var self = this;
		var opts = this.options;

		this.marker = new google.maps.Marker({
			position: self.latlng,
			map: self.map,
			icon: opts.icon,
			zIndex: 1
		});

		if(!opts.callbacks.onClick){
			this.marker.setCursor('default');
		}

		this.set_marker_content();
		this.add_marker_events();

		if(opts.callbacks.onMarkerReady && typeOf(opts.callbacks.onMarkerReady) == 'function'){
			opts.callbacks.onMarkerReady(this);
		}
	},

	set_scalable: function(e){
		if(!this.marker.label) return;

		var self = this;

		google.maps.event.addListener(this.map, 'zoom_changed', function() {
			self.resize(e);
		}.bind(this));
	},

	resize: function(e){
		var zoom = this.get_zoom();

		if(zoom < 10) zoom = 10;

		if(e.zoom_class) e.removeClass(e.zoom_class);
		e.zoom_class = 'zoom_' + zoom;
		e.addClass(e.zoom_class);

		this.set_marker_size(this.get_size_coefficient(zoom));
	},

	set_marker_size: function(scale_coefficient, icon){
		var self = this;
		var opts = this.options;
		var icon = icon || self.marker.icon.url || this.options.icon;

		this.marker.on_hover = (icon == self.options.icon)? false : true;

		var image = new Asset.image(icon, {
			onLoad: function(){
				var marker_size = self.get_marker_size(image);
				var marker_width = self.marker.width = Math.round(marker_size.width * scale_coefficient * opts.size);
				var marker_height = self.marker.height = Math.round(marker_size.height * scale_coefficient * opts.size);
				var size = new google.maps.Size(marker_width, marker_height);

				self.marker.setOptions({
					icon: new google.maps.MarkerImage(
						icon,
						size,
						new google.maps.Point(0,0),
						new google.maps.Point(marker_width/2, marker_height/2),
						size
					)
				});

				if(self.marker.label){
					self.marker.label.resize(marker_width);
				}

				//To make sure the marker is not on hover state on mouseout event
				(function(){
					if(!self.marker.on_hover && self.marker.icon.url != self.options.icon) {
						self.change_icon_image(self.options.icon);
					}
				}.delay(100))
			}
		});
	},

	get_size_coefficient: function(zoom){
		var scale_coefficient;

		switch(zoom){
			case 10:
				scale_coefficient = 0.3
				break;
			case 11:
				scale_coefficient = 0.4
				break;
			case 12:
				scale_coefficient = 0.6
				break;
			case 13:
				scale_coefficient = 0.8
				break;
			case 14:
				scale_coefficient = 1
				break;
			case 15:
				scale_coefficient = 1.2
				break;
			case 16:
				scale_coefficient = 1.5
				break;
			case 17:
				scale_coefficient = 1.8
				break;

			default:
				scale_coefficient = 2
		}

		return scale_coefficient;
	},

	set_marker_content: function(){
		var self = this;
		var opts = this.options;

		var image = new Asset.image(opts.icon, {
			onLoad: function(){
			 	var marker_size = self.get_marker_size(image);
				var marker_height = self.marker.height = Math.round(marker_size.height * opts.size);
				var marker_width = self.marker.width = Math.round(marker_size.width * opts.size);

				var size = new google.maps.Size(marker_width, marker_height);

				if(opts.base_point == 'center'){
					self.marker.setOptions({
						icon: new google.maps.MarkerImage(
							opts.icon,
							size,
							new google.maps.Point(0,0),
							new google.maps.Point(marker_width/2, marker_height/2),
							size
						)
					});
				}

				self.set_label(marker_width, marker_height);
				self.set_bubble(marker_width, marker_height);

				// open the bubble
				if(self.options.init_open) {
					// label mouseover (open the popup)
					self.in_bubble = true;
					google.maps.event.trigger(self.marker, "mouseover");
					// callback click (make the popup stay in the page)
					self.callback_click();
				}
			}
		});
	},

	set_label: function(marker_width, marker_height){
		var self = this;
		var opts = this.options;

		if(!opts.label || !opts.label.content || opts.label.content == '') return;

		var label = this.marker.label = new SimpleMap.Bubble(this.map, this.latlng, {
			content: opts.label.content,
			is_label: true,
			add_class: opts.label.add_class,

			onBubbleReady: function(_el){
				if(opts.scalable){
					self.set_scalable(_el);
					self.resize(_el);
				}
				_el.marker = self;
				_el.addEvents({
					'mouseenter': function(){
						self.in_bubble = true;
					},

					'mouseleave': function(){
						self.in_bubble = false;
					},
					'click': function() {
						self.in_bubble = true;
						google.maps.event.trigger(_el.marker.marker, "mouseover");
					}
				});

				//set the marker of the label
				_el.marker = self;
			}
		});

		label.open();
	},

	set_bubble: function(marker_width, marker_height){
		var self = this;
		var opts = this.options;

		if(!opts.bubble.content || opts.bubble.content == '') return;

		var bubble = this.marker.bubble = new SimpleMap.Bubble(this.map, this.latlng, {
			content: opts.bubble.content,
			z_index: opts.bubble.z_index,
			add_class: opts.bubble.add_class,
			offset: {
				x: opts.bubble.offset.x,
				y: ((opts.base_point == 'center')? marker_height/-2 : marker_height*-1) + opts.bubble.offset.y
			},
			side: opts.bubble.side,
			onBubbleReady: function(_el){
				self.fireEvent('bubbleReady', [_el]);

				_el.addEvents({
					'mouseenter': function(){
						self.in_bubble = true;
					},

					'mouseleave': function(){
						self.in_bubble = false;

						if(!self.marker.clicked){
							bubble.close();
						}
					}
				});
			},
			onBubbleOpen: function(){
				if (self.map.current_bubble && self.map.current_bubble != bubble) {

					if(self.options.current_bubble_open_on_mouseover){
						if (!self.map.current_bubble.infobox._div ||
							(self.map.current_bubble.infobox._div && !self.map.current_bubble.infobox._div.hasClass('_big'))){
							self.map.current_bubble.close();
						}
					}
					else{
						self.map.current_bubble.close();
					}
				}

				self.map.current_bubble = bubble;
			},
			onBubbleClose: function(){
				self.in_bubble = false;
				self.marker.clicked = false;

				google.maps.event.trigger(self.marker, "mouseout");

				if(opts.callbacks.onBubbleClose && typeOf(opts.callbacks.onBubbleClose) == 'function'){
					opts.callbacks.onBubbleClose();
				}
			}
		});
	},

	callback_click: function() {
		if(this.options.center_on_click){
			this.map.panTo(this.latlng);
			this.map.panBy(this.options.panby_onclick.x, this.options.panby_onclick.y);
		}

		if(this.options.callbacks.onClick && typeOf(this.options.callbacks.onClick) == 'function'){
			this.options.callbacks.onClick();
		}

		this.marker.clicked = true;
	},

	add_marker_events: function(){
		var self = this;
		var opts = this.options;

		google.maps.event.addListener(this.marker,
			'mouseover', function(){
				if(opts.callbacks.onStopMouseover && typeOf(opts.callbacks.onStopMouseover) == 'function'){
					if(opts.callbacks.onStopMouseover()){
						return;
					}
				}

				if(self.marker.bubble){
					self.marker.bubble.open();
				}

				if(opts.hover_icon){
					self.marker.on_hover = true;
					self.change_icon_image(opts.hover_icon);
				}

				if(opts.callbacks.onMouseover && typeOf(opts.callbacks.onMouseover) == 'function'){
					opts.callbacks.onMouseover();
				}
			}
		);

		google.maps.event.addListener(this.marker,
			'mouseout', function(){
				if(self.in_bubble) return;

				if(self.marker.bubble && self.marker.bubble.infobox.opened){
					if(!self.marker.clicked){
						self.marker.bubble.close();
					}
				}

				if(opts.callbacks.onMouseout && typeOf(opts.callbacks.onMouseout) == 'function'){
					opts.callbacks.onMouseout();
				}

				if(opts.hover_icon && !self.marker.clicked){
					self.change_icon_image(opts.icon);
				}

				self.map.bubble_options.visible = true;
			}
		);

		google.maps.event.addListener(this.marker,
			'click', self.callback_click.bind(self)
		);
	},

	get_marker_size: function(image){
		if(image){
			return {
				'width': image.width,
				'height': image.height
			};
		}

		return {
			'width': 0,
			'height': 0
		};
	},

	get_zoom: function(){
		return this.map.getZoom();
	},

	change_icon_image: function(icon){
		if(!icon) return;

		this.set_marker_size(this.get_size_coefficient(this.options.scalable? this.get_zoom() : 14), icon);
	},

	remove_from_map: function(){
		this.marker.setMap(null);

		if(this.marker.label){
			this.marker.label.close();
		}
	}
});

SimpleMap.Bubble = new Class({
	Implements: [Events, Options],

	options: {
		lat: 40.773522,
		lng: -73.944862,
		content: '',
		offset: { x: 0, y: 0 },
		visible: true,
		z_index: null,
		add_class: '', //can be used to stylize different types of infoboxes
		enableEventPropagation: true,
		is_label: false, //determine if the bubble is a label of the marker (it always stays open)
		side: 'top' //on which side of marker display infobox. for now supports only 'top' and 'right'
	},

	initialize: function(map, latlng, options){
		if(!map) return;

		this.setOptions(options);
		this.map = map;
		this.latlng = latlng;

		this.build();
	},

	build: function(){
		var self = this;
		var opts = this.options;

		this.latlng = this.latlng || new google.maps.LatLng(opts.lat, opts.lng);

		this.in_bubble_options = {
			scrollwheel: false,
			draggable: false
		};

		this.out_bubble_options = {
			scrollwheel: this.map.scrollwheel,
			draggable: this.map.draggable
		};

		this.addEvent('bubble_ready', function(el){
			self.fireEvent('bubbleReady', [el]);

			self._bubble_content = el;

			if(opts.is_label){
				var cs = self.infobox._div.ownerDocument.defaultView.getComputedStyle(self.infobox._div, "");
				var h = Math.round(cs.height.split('px')[0]);
				var mt = h/2;
				self.infobox._div.setStyle('margin-top', mt);

				return;
			}

			self._bubble_content.addEvents({
				'mouseover': function(){
					self.map.setOptions(self.in_bubble_options);
					self.map.bubble_options.visible = false;
				},

				'mousemove': function(){
					self._bubble_content.fireEvent('mouseover');
				},

				'mouseout': function(){
					self.map.setOptions(self.out_bubble_options);
					self.map.bubble_options.visible = true;
				},

				'mousewheel': function(){
					self._bubble_content.fireEvent('mouseover');
				}
			});

			var _close;

			if(!self.infobox._close){
				self.infobox._close = el.getElement('.w_googlemaps_infobox_close');
			}

			_close = self.infobox._close;

			if(_close){
				_close.addEvent('click', function(e){
					if(e && e.stop) e.stop();

					self.close();
				});
			}

			var _pointer = el._pointer || el.getElement('.w_googlemaps_infobox_pointer');
			el._pointer = _pointer;

			if(_pointer && !_pointer.ml_is_set){
				_pointer.setStyle('margin-left', _pointer.getStyle('margin-left').toInt() - opts.offset.x);
				_pointer.ml_is_set = true;
			}
		});

		var box_class = (opts.is_label? 'w_googlemaps_label' : 'w_googlemaps_infobox') + ' ' + opts.add_class;
		var content = opts.content;

		if(!opts.is_label){
			content = '<div class="w_googlemaps_infobox_content"><div class="w_googlemaps_infobox_close">&nbsp;</div>' + content + '</div><div class="w_googlemaps_infobox_pointer">&nbsp;</div>'
		}

		this.infobox = new SimpleMap.Infobox(this.map, {
			position: this.latlng,
			box_class: box_class,
			content: content,
			pixel_offset: new google.maps.Size(opts.offset.x, opts.offset.y),
			enable_events: true,
			z_index: opts.z_index,
			side: opts.side,

			onBubbleReady: function(el){
				self.fireEvent('bubble_ready', el);
			}
		});
	},

	close: function(){
		if(!this.infobox.opened) return;

		this.infobox.close();

		if(this.infobox.opened){
			this.map.bubble_options.visible = true;
			this.infobox.opened = false;
		}

		if(this._bubble_content){
			this._bubble_content.fireEvent('mouseout');
		}

		this.fireEvent('bubbleClose');
		this.map.setOptions(this.out_bubble_options);
	},

	open: function(){
		if(!this.options.visible || !this.map.bubble_options.visible || this.infobox.opened) return;

		this.infobox.open(this.map);

		this.infobox.opened = true;
		this.fireEvent('bubbleOpen');
	},

	set_visibility: function(visible){
		this.options.visible = visible;
	},

	set_width: function(width){
		if(this._bubble_content){
			this._bubble_content.setStyle('width', width);
		}
	},

	resize: function(width){
		if(this._bubble_content){
			var cs = this._bubble_content.ownerDocument.defaultView.getComputedStyle(this._bubble_content, "");
			var l = Math.round(cs.left.split('px')[0]);
			var w = Math.round(cs.width.split('px')[0]);

			var odd = ((width - w)%2 == 1)? (width - w) : (width - w + 1);
			var nl = l - odd/2;

			this._bubble_content.setStyle('left', nl);
			this.set_width(width);
		}
	}
});

SimpleMap.Infobox = new Class({
	Implements: [Events, Options],

	options: {
		lat: 40.773522,
		lng: -73.944862,
		position: null,
		box_class: '',
		box_style: {},
		content: '',
		pixel_offset: null,
		enable_events: false,
		max_width: 0,
		z_index: null,
		infobox_clearance: null,
		is_hidden: false,
		pane: 'floatPane',
		side: 'top' //on which side of marker display infobox. for now supports only 'top' and 'right'
	},

	initialize: function(map, options){
		this.setOptions(options);

		if(!map) return;

		this.map = map;
		this.build();
	},

	build: function(){
		var opts = this.options;

		this.position = opts.position || new google.maps.LatLng(opts.lat, opts.lng);
		this.infobox_clearance = opts.infobox_clearance || new google.maps.Size(1, 1);

		this._div = null;

		this.mousedown_listener = null;
		this.click_listener = null;
		this.dblclick_listener = null;
		this.context_listener = null;

		this.overlay = new google.maps.OverlayView();
		this.overlay.draw = this.draw.bind(this);
		this.overlay.onRemove = this.onRemove.bind(this);
	},

	draw: function(){
		var opts = this.options;
		var self = this;

		this.create_infobox_div();

		var _imgs = this._div.getElements('img');
		var _imgs_srcs = [];

		_imgs.each(function(_el){
			_imgs_srcs.push(_el.get('src'));
		});

		var __set_div_styles = function(){
			var projection = self.overlay.getProjection();

			if(!projection) return;

			// force parse float for lat/lng (to fix map issue)
			var parsedPosition = new google.maps.LatLng(parseFloat(self.position.lat()), parseFloat(self.position.lng()));
			var pixPosition = projection.fromLatLngToDivPixel(parsedPosition); 

			var cs = self._div.ownerDocument.defaultView.getComputedStyle(self._div, "");
			var size = {x:Math.round(cs.width.split('px')[0]), y: Math.round(cs.height.split('px')[0])}

			if(opts.side == 'top'){
				self._div.setStyles({
					'left': pixPosition.x + opts.pixel_offset.width - size.x/2,
					'top': pixPosition.y + opts.pixel_offset.height - size.y,
					'visibility': (opts.is_hidden? 'hidden' : 'visible')
				});
			}else{
				self._div.setStyles({
					'left': pixPosition.x + opts.pixel_offset.width,
					'top': pixPosition.y + opts.pixel_offset.height,
					'visibility': (opts.is_hidden? 'hidden' : 'visible')
				});
			}
		};

		if(_imgs && _imgs.length > 0){
			new Asset.images(_imgs_srcs, {
				onComplete: function(){
					__set_div_styles();
				},
				onError: function(){
					__set_div_styles();
				}
			});
		}else{
			__set_div_styles();
		}
	},

	onRemove: function(){
		if(this._div){
			this._div.dispose();
		}
	},

	create_infobox_div: function(){
		var opts = this.options;

		if(!this._div){
			this._div = new Element('div');

			this.set_box_style();

			if(typeOf(opts.content) == 'string' || typeOf(opts.content) == 'number'){
				this._div.set('html', opts.content);
			}else if(typeOf(opts.content) == 'element'){
				this._div.set('html', '');
				this._div.adopt(opts.content);
			}else{
				return;
			}

			var panes = this.overlay.getPanes();

			if(panes){
				panes[opts.pane].appendChild(this._div);
			}

			if(!this._div.style.width){
				if(opts.max_width !== 0 && this._div.offsetWidth > opts.max_width){
					this._div.style.width = opts.max_width;
					this._div.style.overflow = "auto";
				}else{
					var bw = this.get_box_width();

					this._div.style.width = (this._div.offsetWidth - bw.left - bw.right) + "px";
				}
			}

			var __cancel_handler = function(e){
				e.cancelBubble = true;

				if(e.stopPropagation){
					e.stopPropagation();
				}
			};

			var __ignore_handler = function(e){
				e.returnValue = false;

				if(e.preventDefault){
					e.preventDefault();
				}

				if(!opts.enable_events){
					__cancel_handler(e);
				}
			};

			if(!opts.enable_events){
				this.mousedown_listener = google.maps.event.addDomListener(this._div, "mousedown", __cancel_handler);
				this.click_listener = google.maps.event.addDomListener(this._div, "click", __cancel_handler);
				this.dblclick_listener = google.maps.event.addDomListener(this._div, "dblclick", __cancel_handler);
			}

			this.context_listener = google.maps.event.addDomListener(this._div, "contextmenu", __ignore_handler);

			google.maps.event.trigger(this, "domready");
		}else{
			var panes = this.overlay.getPanes();

			if(panes){
				panes[opts.pane].appendChild(this._div);
			}
		}

		this.fireEvent('bubbleReady', [this._div]);
	},

	set_box_style: function(){
		var opts = this.options;

		if(this._div){
			this._div.set('class', opts.box_class);

			var styles = {
				'position': 'absolute',
				'visibility': 'hidden'
			};

			if (opts.z_index) {
				styles['z-index'] = opts.z_index;
			}

			this._div.setStyles(styles);
		}
	},

	get_box_width: function(){
		var _box = this._div;
		var bw = {};

		if(document.defaultView && document.defaultView.getComputedStyle){
			var computedStyle = _box.ownerDocument.defaultView.getComputedStyle(_box, "");

			if(computedStyle){
				bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0;
				bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
				bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0;
				bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0;
			}
		}else if(document.documentElement.currentStyle){
			if(_box.currentStyle){
				bw.top = parseInt(_box.currentStyle.borderTopWidth, 10) || 0;
				bw.bottom = parseInt(_box.currentStyle.borderBottomWidth, 10) || 0;
				bw.left = parseInt(_box.currentStyle.borderLeftWidth, 10) || 0;
				bw.right = parseInt(_box.currentStyle.borderRightWidth, 10) || 0;
			}
		}

		return bw;
	},

	set_position: function(latlng){ //used outside of the class
		this.position = latlng;

		if(this._div){
			this.draw();
		}

		google.maps.event.trigger(this, "position_changed");
	},

	get_position: function(){
		return this.position;
	},

	open: function(map){
		this.overlay.setMap(this.map);
	},

	close: function(){
		if(this.mousedown_listener){
			google.maps.event.removeListener(this.mousedown_listener);
			google.maps.event.removeListener(this.click_listener);
			google.maps.event.removeListener(this.dblclick_listener);

			this.mousedown_listener = null;
			this.click_listener = null;
			this.dblclick_listener = null;
		}

		if(this.context_listener){
			google.maps.event.removeListener(this.context_listener);
			this.context_listener = null;
		}

		this.overlay.setMap(null);
	}
});
